/* Atualização das condições globais de pagamento da Aya. */
(function () {
  'use strict';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    if (number == null || isNaN(number)) return '0';

    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || 'R$ {{ amount_with_comma_separator }}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) return String(cents / 100);

    var value;
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, '.', ',');
    }

    return format.replace(placeholderRegex, value);
  }

  function belongsToVariant(element, variantId) {
    var ids = (element.getAttribute('data-variant-ids') || '').split(',');
    return ids.indexOf(String(variantId)) !== -1;
  }

  function calculateInstallments(price, maxInstallments, minimumCents) {
    var count = 1;
    var value = price;

    for (var candidate = maxInstallments; candidate >= 2; candidate -= 1) {
      var candidateValue = Math.floor(price / candidate);
      if (candidateValue >= minimumCents) {
        count = candidate;
        value = candidateValue;
        break;
      }
    }

    return { count: count, value: value };
  }

  function updatePayment(element, variant) {
    var price = Number(variant.price || 0);
    var discount = Number(element.getAttribute('data-pix-discount') || 0);
    var maxInstallments = Number(element.getAttribute('data-installments-max') || 1);
    var minimumCents = Number(element.getAttribute('data-installment-min-cents') || 0);

    var pixValue = element.querySelector('[data-aya-payment-pix-value]');
    if (pixValue) {
      var pixPrice = Math.floor(price * (100 - discount) / 100);
      pixValue.textContent = formatMoney(pixPrice);
    }

    var installmentsLine = element.querySelector('[data-aya-payment-installments]');
    if (installmentsLine) {
      var installments = calculateInstallments(price, maxInstallments, minimumCents);
      installmentsLine.hidden = installments.count <= 1;

      var countElement = installmentsLine.querySelector('[data-aya-payment-installments-count]');
      var valueElement = installmentsLine.querySelector('[data-aya-payment-installments-value]');
      if (countElement) countElement.textContent = installments.count;
      if (valueElement) valueElement.textContent = ' ' + formatMoney(installments.value);
    }
  }

  function updateStandalonePrice(element, variant) {
    var priceElement = element.querySelector('[data-price]');
    var compareElement = element.querySelector('[data-compare-price]');
    var hasComparePrice = Number(variant.compare_at_price || 0) > Number(variant.price || 0);

    if (priceElement) priceElement.textContent = formatMoney(variant.price || 0);
    if (compareElement) {
      compareElement.textContent = hasComparePrice ? formatMoney(variant.compare_at_price) : '';
      compareElement.hidden = !hasComparePrice;
    }
  }

  function isDynamicProductContext(element) {
    var context = element.getAttribute('data-payment-context');
    return context === 'product' || context === 'quick-view' || context === 'featured';
  }

  document.addEventListener('product:variant-change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    window.requestAnimationFrame(function () {
      document.querySelectorAll('[data-aya-payment]').forEach(function (element) {
        if (isDynamicProductContext(element) && belongsToVariant(element, variant.id)) {
          updatePayment(element, variant);
        }
      });

      document.querySelectorAll('[data-aya-product-price]').forEach(function (element) {
        if (belongsToVariant(element, variant.id)) updateStandalonePrice(element, variant);
      });
    });
  });
})();
